import { Grid, Typography } from '@alice-financial/pretext-ui'
import * as React from 'react'
import { PageBody } from '../../../routes/PageBody'
import { KycInstructions } from '../../onboarding/steps/kyc'
import { useOrg } from '../../organization/useOrg'
import { CompanyRepresentativeComponent, CompanyRepresentativeInstructions } from './CompanyRepresentative'

export const CompanyRepresentativePage = () => {
  const org = useOrg()
  if (!org) return 'Loading...'
  return (
    <PageBody maxWidth="lg">
      <Typography variant="h1" gutterBottom>
        Company Representative
      </Typography>

      <Grid container spacing={2} flexDirection="row-reverse">
        <Grid size={{ xs: 12, md: 4 }}>
          <Typography variant="h4" color="text.secondary" gutterBottom>
            Instructions
          </Typography>

          <KycInstructions />
        </Grid>
        <Grid size={{ xs: 12, md: 8 }}>
          <CompanyRepresentativeInstructions />
          <CompanyRepresentativeComponent org={org} />
        </Grid>
      </Grid>
    </PageBody>
  )
}
